<style src="./Epg.css"></style>
<template>
  <div class="epg"

       :class="[{'epg--fixed' : fixedHeader, 'epg--show' : showEpg}]"
  >
    <div class="">
      <!-- Days selection -->
      <Days ref="epgDays"
            @epgSelectDay="selectDay"
            @epgNow="now"
            :now-label="now_label[lang]"
            :selected-date="selectedDate"
            :today-label="today_label[lang]" />

      <!-- Channels info -->
      <Channels
              ref="epgChannels"
              :expanded-slot-height="expandedSlotHeight"
              :default-expanded-slot-height="defaultExpandedSlotHeight"
              :default-time-slot-height="defaultTimeSlotHeight"
              :images="channelImages"
              :channels="channels"
              :empty-image-url="emptyImageUrl"
              v-if="channels.length > 0"
      />
    </div>

    <!-- Draggable timeline- -->
    <div class="epg__timeline-wrapper">
      <div
        :class="['epg__timeline--notransition']"
        draggable="false"
        @mousemove="handleDragMove"
        @touchmove="handleDragMove"
        @mousedown="onDragStart"
        @mouseup="onDragEnd"
        @mouseleave="onDragEnd"
        @touchstart="onDragStart">

        <div class="epg__btn epg__btn--left" v-on:click="previousPage()">
          <svg class="epg__chevron">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-chevron-left"></use>
          </svg>
        </div>
        <div class="epg__btn epg__btn--right" v-on:click="nextPage()">
          <svg class="epg__chevron">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-chevron-right"></use>
          </svg>
        </div>
        <div  v-if="showLoader">
            <div class="loader__spinner-container epg__loader">
                  <div class="loader__spinner"></div>
            </div>
        </div>
        <div
          :style="styles"
          :class="['epg__inner--notransition']"
          ref="timeline">

          <div class="epg__now-time-label" v-if="showNowElements"
               :style="'left:'+nowOffset"></div>
          <div class="epg__now-time-cover" v-if="showNowElements"
               :style="'width:'+nowOffset"></div>

          <!-- Time indicator -->
          <div class="epg__times epg__timeslots">
            <div
              v-for="d in slotsByMinutes"
              class="epg__timeslot"
              :style="`width:${pixelsPerMinute * 30}px`">
              {{d}}
            </div>
          </div>
          <div v-if="channels.length > 0">
            <transition name="fade--area">
              <div v-if="!showLoader &&  channels.length > 0">
                    <ChannelRow
                            v-for="(ch, index) in channels"
                            :timeline-rect="timelineRect"
                            :key="ch.id + index"
                            :pre-cache-height="channelsToPreCache * channelHeight"
                            :horizontal-debounce="horizontalDebounce"
                            :set-channel-visibility="setChannelVisibility"
                            :is-grabbed="containerPos"
                            :is-scrolling="isScrolling"
                            :channel="ch"
                            :pixels-per-minute="pixelsPerMinute"
                            :container-pos="containerPos"
                            :timeline-width="timelineWidth"
                            :selectProgram="selectProgram"
                            :more-label="more_label[lang]"
                            :less-label="less_label[lang]"
                            :close-slot="clearSelectedProgram"
                            :default-expanded-slot-height="defaultExpandedSlotHeight"
                            :default-time-slot-height="defaultTimeSlotHeight"
                            :expanded-slot-height="expandedSlotHeight"
                            :description-truncation-point="descriptionTruncationPoint"
                            :set-expanded-slot-height="setExpandedSlotHeight"
                            :show-program-loader="showProgramLoader"
                            :selected-program="selectedProgram"
                    />
              </div>
            </transition>
          </div>
        </div>

      </div>
    </div>

    <!-- Pagination-->
    <div class="epg__pagination align--center" v-if="showPagination && selectedFilters.length === 0 && !pagination.isLast" @click="showMore">
      <div class="button button--transparent button--white">{{pagination_label[lang]}}</div>
    </div>

  </div>
</template>

<script>
import { polyfill } from 'es6-promise'
import moment from 'moment'
import MomentIterator from 'moment-iterator'
import axios from 'axios'
import Days from '../Days/Days'
import Channels from '../Channels/Channels'
import SelectedSlot from '../SelectedSlot/SelectedSlot'
import Program from '../Program/Program'
import ChannelRow from '../ChannelRow/ChannelRow'
import { throttle } from 'lodash'
import { linear } from '../utils/easing'

const ease = linear

export default {
  name: 'epg',
  components: { Days, Channels, SelectedSlot, Program, ChannelRow },
  data () {
    return {
      fakeData: false,
      containerPos: 0,
      move: 0,
      isGrabbed: false,
      fixedHeader: false,
      lang: 'el_GR',
      showLoader: false,
      showProgramLoader: false,
      showNowElements: false,
      startTime: moment().startOf('day').add(0, 'minutes'),
      pixelsPerMinute: 6,
      emptyImageUrl: 'static/noimage.png',
      getEpgUrl: null,
      getProgramUrl: null,
      goToProgramUrl: '/someurl/',
      emptySlotContent: 'Off air',
      timelineDurationHours: 24,
      currentTime: moment(),
      selectedDate: moment(),
      updateNowInterval: 10000,
      showLoaderInterval: 200,
      resizeInterval: 300,
      resizeTimer: null,
      scrollInterval: 0,
      scrollTimer: null,
      isScrolling: 0,
      horizontalDebounce: 300,
      channelsToPreCache: 5,
      channelHeight: 80,
      isIE: false,
      showEpg: false,
      mobileBreakPoint: 768,
      mobilePixelsPerMinute: 2,
      desktopPixelsPerMinute: 6,
      channelImages: [],
      now_label: {
        en: 'now',
        el_GR: 'τώρα'
      },
      today_label: {
        en: 'Today',
        el_GR: 'Σήμερα'
      },
      more_label: {
        en: 'More',
        el_GR: 'Περισσότερα'
      },
      less_label: {
        en: 'Less',
        el_GR: 'Λιγότερα'
      },
      pagination_label: {
        en: 'See more',
        el_GR: 'Δες περισσότερα'
      },
      nowOffset: 0,
      timelineRect: null,
      selectedProgram: {},
      timelineWidth: 0,
      showPagination: true,
      pageSize: 8,
      pagination: {
        firstIndex: 0,
        lastIndex: 0,
        currentLastIndex: 0,
        isLast: false,
        isFirst: true
      },
      defaultExpandedSlotHeight: 170,
      defaultTimeSlotHeight: 80,
      expandedSlotHeight: 170,
      originalChannelsData: [],
      channels: [],
      selectedFilters: []
    }
  },
  created () {
    const self = this
    polyfill()

    this.startTime = this.selectedDate.startOf('day').add(0, 'minutes')
    this.slotsByMinutes = MomentIterator(moment(this.startTime.format()), moment(this.endTime.format())).range('30 minutes', {format: 'HH:mm'})
    this.showNowElements = this.currentTime.isSame(this.selectedDate, 'day')

    // live currentTime
    setInterval(() => { self.currentTime = moment() }, self.updateNowInterval)
  },
  mounted () {
    const self = this
    console.log('EPG: mounted')

    // show the epg with an opacity after 1sec
    setTimeout(() => {
      this.showEpg = true
    }, 1000)

    this.isIE = (typeof document.createElement('span').dragDrop === 'function')
    this.nowOffset = this._getOffsetByTime(this.currentTime) + 'px'
    this.timelineWidth = this.$refs.timeline.offsetWidth
    this.timelineRect = this.$refs.timeline.getBoundingClientRect()
    this.channelImages = this._imagesArrayToObject(this.channelImages)

    if (this.showPagination) {
      this.pagination.currentLastIndex = this.pageSize
    }
    this.calculatePixelsPerMinute()
    // this.$refs.epgDays.setUpDays(this.today_label[this.lang])
    this.now()
    this.onLanguageChange()
    // this.$refs.epgDays.recalculate()

    window.addEventListener('resize', () => {
      window.clearTimeout(self.resizeTimer)

      self.resizeTimer = window.setTimeout(() => {
        self.resizeHandler()
      }, self.resizeInterval)
    })

    window.addEventListener('scroll', this.scrollHandler)
  },
  destroyed () {
    const self = this
    window.removeEventListener('resize', self.resizeHandler)
    window.removeEventListener('scroll', self.scrollHandler)
    window.setTimeout(self.resizeTimer)
  },
  watch: {
    timelineWidth: function () {
      this.calculatePixelsPerMinute()
    },
    lang: function () {
      this.onLanguageChange()
    },
    pixelsPerMinute: function () {
      this.recalculate()
    },
    getEpgUrl: function () {
      this.loadData(moment())
    },
    currentTime: function () {
      this.nowOffset = this._getOffsetByTime(this.currentTime) + 'px'
    },
    selectedDate: function () {
      this.showNowElements = this.currentTime.isSame(this.selectedDate, 'day')
    },
    selectedFilters: function () {
      this.filterData()
    }
  },
  computed: {
    styles () {
      return {
        transform: `translate(${this.containerPos}px, 0)`
      }
    },
    endTime () {
      return moment(this.startTime).add(this.timelineDurationHours, 'hours')
    },
    descriptionTruncationPoint () {
      return (this.timelineWidth < this.mobileBreakPoint) ? 50 : 200
    }
  },
  methods: {
    recalculate () {
      this.calculatePixelsPerMinute()
      this.nowOffset = this._getOffsetByTime(this.currentTime) + 'px'
      this.timelineWidth = this.$refs.timeline.offsetWidth

      this.loadData(this.selectedDate)
    },
    /*
     * Adjust slot withing viewport visible boundaries,
     * Depending on where the slot is located adjust either from the left or
     * from the right so that the whole slot will be visible
     */
    _adjustSlot (slot) {
      // Do nothing on empty slots
      if (slot._emptySlot) return false

      // When slot's range exceeds start + end time
      // Adjust slot on it's start time (left)
      if (slot._start.format('X') < this.getStartTime().format('X') &&
        slot._end.format('X') > this.getEndTime().format('X')) {
        this.goto(slot._start)
        return
      }

      // if the slot's width is bigger than the visible range
      // Adjust slot on it's start time (left)
      if (slot._end.format('X') - slot._start.format('X') > this.getEndTime().format('X') - this.getStartTime().format('X')) {
        this.goto(slot._start)
        return
      }

      // Make whole slot visible from the left
      if (slot._start.format('X') < this.getStartTime().format('X') &&
        slot._end.format('X') > this.getStartTime().format('X')) {
        let timespan = Math.abs(moment.utc(this.getStartTime().diff(slot._start)).format('mm'))
        let newOffset = this.getStartTime().subtract(timespan, 'minutes')
        this.goto(newOffset)
        return
      }

      // Make whole slot visible from the right
      if (slot._start.format('X') < this.getEndTime().format('X') &&
        slot._end.format('X') > this.getEndTime().format('X')) {
        let timespan = Math.abs(moment.utc(slot._end.diff(this.getEndTime())).format('mm'))
        let newOffset = this.getStartTime().add(timespan, 'minutes')
        this.goto(newOffset)
        return
      }
    },
    /*
     * Dragstart & touchstart handler
     * Set initial required data (start position, and disable drag image)
     */
    onDragStart (e) {
      // console.log(e)
      this.isGrabbed = true
      this.mouseDownTimestamp = moment().format('x')
      this.mouseStartPosX = (e.targetTouches) ? e.targetTouches[0].clientX : e.clientX
      this.mouseStartPosY = (e.targetTouches) ? e.targetTouches[0].pageY : e.pageY
      this.leftBoundary = 0
      this.rightBoundary = (this.slotsByMinutes.length * this.pixelsPerMinute * 30) - this.$refs.timeline.offsetWidth

      // console.log('onDragStart', this.mouseStartPosY)
    },
    /*
     * Dragend handler
     * Set initial required data (start position, and disable drag image)
     */
    onDragEnd (e) {
      this.isGrabbed = false
      this.moveX = null
      this.moveY = null
    },
    /*
     * Main horizontal drag and touchmove handler
     */
    onDragMove (e) {
      // e.stopPropagation()
      // e.preventDefault()
      if (!this.isGrabbed || this.selectedProgram.id) {
        return false
      }

      if (this.selectedProgram.id && moment().format('x') - this.mouseDownTimestamp > 150) {
        this.clearSelectedProgram()
      }

      // Get the left offset of the mouse drag (depending touch or desktop)
      this.mousePosX = (e.targetTouches) ? e.targetTouches[0].pageX : e.pageX
      this.mousePosY = (e.targetTouches) ? e.targetTouches[0].pageY : e.pageY

      let lastMove = 0
      let eventThrottle = 1
      let now = Date.now()

      // Apply new positions use requestAnimationFrame because IE dies
      if (now > lastMove + eventThrottle) {
        lastMove = now
        requestAnimationFrame(this.applyPosition)
      }
    },
    applyPosition () {
      // let previousMove = this.moveX
      this.moveX = -(this.mouseStartPosX - this.mousePosX)
      this.moveY = this.mouseStartPosY ? -(this.mouseStartPosY - this.mousePosY) : 0
      this.mouseStartPosX = this.mousePosX
      // console.log(this.moveX)
      // handle scrollY
      // if (Math.abs(this.moveY) > 35) {
        // let currentScrollY = window.pageYOffset || document.documentElement.scrollTop
        // window.scrollTo(window.pageXOffset, document.documentElement.scrollTop - this.moveY)
      // }
      // Don't exceed the left boundary
      if (this.containerPos + this.moveX > this.leftBoundary) {
        this.containerPos = this.leftBoundary
        return false
      } else if (Math.abs(this.containerPos + this.moveX) > this.rightBoundary) {
        // Don't exceed the right boundary
        this.containerPos = -this.rightBoundary
        return false
      }

      this.containerPos += this.moveX

      // this.mouseStartPosX = this.mousePosX
      // this.mouseStartPosY = this.mousePosY
    },
    handleDragMove (ev) {
      throttle(() => {
        this.onDragMove(ev)
      }, 1)()
    },
    setLanguage (lang) {
      this.lang = lang
    },
    setExpandedSlotHeight (height) {
      this.expandedSlotHeight = height
    },
    /*
     * Handle language change
     * Change the momentjs locale and recalculate the days part
     */
    onLanguageChange () {
      moment.locale(this.lang)
      this.startTime = this.selectedDate.startOf('day').add(0, 'minutes')
      this.slotsByMinutes = MomentIterator(moment(this.startTime.format()), moment(this.endTime.format())).range('30 minutes', {format: 'HH:mm'})
      this.showNowElements = this.currentTime.isSame(this.selectedDate, 'day')
      // this.$refs.epgDays.setUpDays(this.today_label[this.lang])
      this.$refs.epgDays.recalculate(this.today_label[this.lang])
    },
    // For some strange reason images is an array of strings that need to be processed to an object
    _imagesArrayToObject (arr) {
      let obj = {}

      for (let i = 0; i < arr.length; i++) {
        obj[arr[i].substring(0, arr[i].indexOf(':'))] = arr[i].substring(arr[i].indexOf(':') + 1, arr[i].length)
      }
      return obj
    },
    /*
     * Given time input,
     * get container's new offset in pixels
     * @params time {Object} Momentjs object
     */
    _getOffsetByTime (time) {
      let self = this
      let timestamp = time.format('X')
      let pixels = 0

      MomentIterator(this.startTime, this.endTime).each('1 minutes', (d) => {
        pixels = (d.format('X') <= timestamp) ? pixels + self.pixelsPerMinute : pixels
      })
      return pixels
    },

    /*
     * Limit movement in provided day range
     */
    _applyConstrains () {
      const self = this

      // At the beginning (left end)
      if ((this.containerPos + this.moveX) > 40) {
        setTimeout(() => { self.containerPos = 0 }, 50)
      }
      // At the end (right end)
      let endOffset = Math.abs(this.containerPos - this.$refs.timeline.offsetWidth)
      let fullRangeWidth =
        ((moment(this.endTime).diff(this.startTime) / 60) / 1000) * this.pixelsPerMinute

      if (fullRangeWidth < endOffset) {
        setTimeout(() => {
          self.containerPos = -fullRangeWidth + this.$refs.timeline.offsetWidth
        }, 10)
      }
    },
    /*
     * Go to current time and center-align it
     */
    now () {
      let visibleRange = (this.$refs.timeline.offsetWidth / this.pixelsPerMinute) / 2
      let newPos = moment().subtract(visibleRange, 'minutes')
      this.nowOffset = this._getOffsetByTime(this.currentTime) + 'px'

      if (this.selectedDate.isSame(moment(), 'day')) {
        this.goto(newPos)
      } else {
        this.selectDay(moment())
      }
    },
    /*
     * Go to selected slot/time
     */
    goto (time) {
      let datetime = moment(time)
      if (!datetime.isValid()) return console.error('[Error in goto]: invalid date ')
      const newPosition = -this._getOffsetByTime(datetime)
      // this.containerPos = newPosition
      // this._applyConstrains()
      // return this.containerPos

      // Javascript animation over CSS3 animation prefered, cause on next /prev buttons we count on the changed
      // containerPos to update the inViewport of each Program
      this.animateValue(this.containerPos, newPosition, 300, (val) => {
        this.containerPos = val
      })
    },
    /*
     * Animates a value using ease and uses the onUpdate function to update whatever needs updating
     */
    animateValue (startValue = 0, endValue, duration, onUpdate) {
      const startTime = Date.now()
      window.animationId = null

      function animate () {
        const now = Date.now()
        const t = duration > 0 ? (now - startTime) / duration : 1
        let newValue = startValue + ((endValue - startValue) * ease(t))
        let lastMove = 0
        let eventThrottle = 1

        // when completed set the endValue
        if (t > 1 && now > lastMove + eventThrottle) {
          onUpdate(endValue)
          return
        }
        onUpdate(newValue)
        window.animationId = requestAnimationFrame(animate)
      }
      animate()
    },
    /*
    * Set the pixels per minute based on the timeline width (responsive feature)
    */
    calculatePixelsPerMinute () {
      if (this.timelineWidth < this.mobileBreakPoint) {
        this.pixelsPerMinute = this.mobilePixelsPerMinute
      } else {
        this.pixelsPerMinute = this.desktopPixelsPerMinute
      }
    },
    /*
     * Go to next page.
     * Calculates the range of the visible portion and determines
     * page size/range dynamically.
     */
    nextPage () {
      let visibleRange = this.$refs.timeline.offsetWidth / this.pixelsPerMinute
      let newPos = this.getStartTime().add(visibleRange, 'minutes')
      let endPos = moment(this.endTime).subtract(visibleRange, 'minutes')

      this.clearSelectedProgram()

      if (newPos.isBefore(endPos)) {
        this.goto(newPos)
      } else {
        this.goto(endPos)
      }
    },
    /*
     * Go to previous page.
     * Calculates the range of the visible portion and determines
     * page size/range dynamically.
     */
    previousPage () {
      let visibleRange = this.$refs.timeline.offsetWidth / this.pixelsPerMinute
      let newPos = this.getStartTime().subtract(visibleRange, 'minutes')
      let startPos = moment(this.startTime)

      this.clearSelectedProgram()

      // Don't loop
      // if (this.getStartTime().format('HH') < newPos.format('HH')) newPos = this.startTime
      // this.goto(newPos)

      if (newPos.isBefore(startPos)) {
        // this.goto(startPos)
        this.containerPos = 0
      } else {
        this.goto(newPos)
      }
    },
    /*
     * Get the visible start time
     */
    getStartTime () {
      let ppm = this.pixelsPerMinute
      // let timePast = Math.abs(((this.containerPos + ppm) / ppm) / 60)
      let timePast = Math.abs((this.containerPos / ppm) / 60)
      return moment(this.startTime.format()).add(timePast, 'hours')
    },
    /*
     * Get the visible end time
     */
    getEndTime (time) {
      let visibleRange = this.$refs.timeline.offsetWidth / this.pixelsPerMinute
      return moment(this.getStartTime().format()).add(visibleRange, 'minutes')
    },
    /*
     * Prepare slots
     * Sort, Validate, Interpolate
     */
    _prepareSlots (slots) {
      // TODO: Validate slots (overlapping slots etc)
      this._sortSlots(slots)
      return this._slotInterpolation(this._validateSlots(slots))
    },
    _validateSlots (slots) {
      const currentStartTime = this.startTime.format('X')
      const currentEndTime = this.endTime.format('X')
      return slots.filter(i => {
        const itemStartTime = moment(i.startTime).format('X')
        const itemEndTime = moment(i.endTime).format('X')
        return itemStartTime >= currentStartTime && itemStartTime <= currentEndTime &&
          itemEndTime >= currentStartTime && itemEndTime <= currentEndTime
      })
    },
    /*
     * Fill with empty slots
     * Given timeslots with durations, interpolate with empty timeslots where necessary
     * The output will be a full 24hour list of slots with no empty space in between
     */
    _slotInterpolation (slots) {
      let previousTime = moment(this.startTime)
      let endTime = moment(this.endTime)
      let output = []
      slots.forEach((s) => {
        let slot = this.prepareSlot(s)

       // console.log(this.startTime.format('DD/MM/YYYY HH:mm:ss'))

        // Cutting slots at the begining
        if (slot._start.format('X') < this.startTime.format('X')) {
          // Cut slot to adjust to day's start time
          if (slot._end.format('X') > this.startTime.format('X')) {
            slot.startTime = this.startTime.format()
            slot = this.prepareSlot(slot)
          } else {
            // Slot started and ended before startTime, remove it
            slot._outdated = true
          }
        }

        let timespan = Math.abs(moment.utc(slot._start.diff(previousTime)).format('H.mm'))
        if (timespan > 0 && previousTime < slot._start) {
          output.push(this._createEmptySlot(previousTime.format(), slot._start.format()))
        }

        if (!slot._outdated) {
          previousTime = slot._end
          output.push(slot)
        }
      })

      // Add ending slot
      let endspan = moment.utc(endTime.diff(previousTime)).format('H.mm')
      if (endspan > 0) output.push(this._createEmptySlot(previousTime.format(), endTime.format()))
      return output
    },
    /*
     * Sort slots by start time (ascending)
     */
    _sortSlots (slots) {
      return slots.sort((a, b) => {
        return moment(a.startTime).format('X') - moment(b.startTime).format('X')
      })
    },
    /*
     * Prepare and create a empty slot object with default values
     */
    _createEmptySlot (start, end) {
      return this.prepareSlot({
        title: this.emptySlotContent,
        startTime: start,
        endTime: end,
        _emptySlot: true
      })
    },
    prepareSlot (slot) {
      slot._isSelected = false
      slot._start = moment(slot.startTime)
      slot._end = moment(slot.endTime)
      slot._emptySlot = slot._emptySlot
      slot._duration = Math.abs((slot._end.diff(slot._start, 'minutes')))
      slot._isLive = parseFloat(this.currentTime.format('X')) > parseFloat(slot._start.format('X')) &&
                      parseFloat(this.currentTime.format('X')) < parseFloat(slot._end.format('X'))
      slot._nowLineOffset = ((this.currentTime.diff(slot._start) / 1000) / 60) * 8
      slot._isBeforeNow = parseFloat(this.currentTime.format('X')) > parseFloat(slot._start.format('X'))
      return slot
    },
    recalculateNowLine () {
      const self = this
      self.channels = self.channels.map((channel) => {
        const slots = channel.slots
        channel.slots = slots.map((slot) => {
          slot._nowLineOffset = ((this.currentTime.diff(slot._start) / 1000) / 60) * 8
          return slot
        })

        return channel
      })
    },
    /*
     * Close the selected program
     */
    clearSelectedProgram () {
      this.selectedProgram = {}

      // clear the selected height
      this.expandedSlotHeight = this.defaultExpandedSlotHeight

      this.channels = this.channels.map((channel) => {
        channel.slots.map((slot) => {
          slot._isSelected = false
        })

        channel._isSelected = false
        return channel
      })
    },
    /*
     * Load the selected program
     */
    selectProgram (s) {
      const self = this

      // this is a hack to distinguish between mousedown for drag / clicking
      if (moment().format('x') - this.mouseDownTimestamp > 150) return false

      // close the slot if the same program has been selected
      if (s.id === this.selectedProgram.id) {
        this.clearSelectedProgram()
        return false
      }

      this._adjustSlot(s)

      this.showProgramLoader = true

      this.channels = this.channels.map((channel) => {
        let channelIsSelected = false
        channel.slots.map((slot) => {
          if (slot.id && slot.id === s.id) {
            channelIsSelected = !slot._isSelected
            slot._isSelected = !slot._isSelected
          } else {
            slot._isSelected = false
          }
          return slot
        })

        channel._isSelected = channelIsSelected
        return channel
      })

      axios({
        method: 'get',
        url: this.getProgramUrl,
        params: {
          programId: s.id,
          type: 'programDetail',
          locale: self.lang
        }
      })
      .then(function (response) {
        const programData = {...response.data.program}
        programData.id = s.id
        programData.url = self.goToProgramUrl + s.id
        programData.suitabilityImageSrc = `/ext_files/images/tv/${programData.suitabilityImg}.png`

        self.selectedProgram = programData
        setTimeout(() => { self.showProgramLoader = false }, self.showLoaderInterval)
      })
      .catch(() => {
        setTimeout(() => { self.showProgramLoader = false }, self.showLoaderInterval)
      })
    },
    fakeDataGeneration (channelsData) {
      console.log('EPG: Will generate fake data!')
      const selectedDate = this.selectedDate
      return channelsData.map((item) => {
        item.programs.map((program) => {
          const startDay = moment(program.startTime).get('date')
          const startHours = moment(program.startTime).get('hours')
          const startMins = moment(program.startTime).get('minutes')
          const startSecs = moment(program.startTime).get('seconds')

          const endDay = moment(program.endTime).get('date')
          const endHours = moment(program.endTime).get('hours')
          const endMins = moment(program.endTime).get('minutes')
          const endSecs = moment(program.endTime).get('seconds')

          if (+startDay === 11) {
            program.startTime = moment(selectedDate)
            .set({
              hours: startHours,
              minutes: startMins,
              seconds: startSecs
            })
            .format('YYYY-MM-DD HH:mm:ss')
          } else {
            program.startTime = moment(selectedDate).add(1, 'days')
            .set({
              hours: startHours,
              minutes: startMins,
              seconds: startSecs
            })
            .format('YYYY-MM-DD HH:mm:ss')
          }

          if (+endDay === 11) {
            program.endTime = moment(selectedDate)
            .set({
              hours: endHours,
              minutes: endMins,
              seconds: endSecs
            })
            .format('YYYY-MM-DD HH:mm:ss')
          } else {
            program.endTime = moment(selectedDate).add(1, 'days')
            .set({
              hours: endHours,
              minutes: endMins,
              seconds: endSecs
            })
            .format('YYYY-MM-DD HH:mm:ss')
          }

          return program
        })
        return item
      })
    },
    // this is for changing the original data from an external component
    setOptions (configObj) {
      for (let i in configObj) {
        this[i] = configObj[i]

        if (i === 'channelImages') {
          this.channelImages = this._imagesArrayToObject(this.channelImages)
        }
      }
      this.recalculate()
    },
    selectDay (date) {
      console.log('EPG: Selected Date: ' + date)
      this.selectedDate = moment(date)
      this.startTime = moment(date).startOf('day').add(0, 'minutes')
      this.channels = []
      this.showLoader = true
      this.loadData(date)

      if (!this.selectedDate.isSame(moment(), 'day')) {
        this.goto(0)
      }

      setTimeout(() => this.$refs.epgDays.centerOnSelectedDay(date), 200)
    },
    // load the data for the specific date
    loadData (date) {
      const self = this
      self.showLoader = true

      axios({
        method: 'get',
        url: this.getEpgUrl,
        params: {
          type: 'programSchedule',
          locale: self.lang,
          startDate: date.format('MM/DD/YYYY'),
          endDate: date.format('MM/DD/YYYY')
        }
      })
      .then(function (response) {
        // let channelsData = response.data.schedule.channels
        // ToDo: Remove this, it's just until we get the correct endpoints
        let channelsData = self.fakeData ? self.fakeDataGeneration(response.data.schedule.channels) : response.data.schedule.channels

        self.channels = channelsData.map((item) => {
          return {
            id: item.id,
            category: item.category,
            name: item.name,
            image: item.image,
            _isSelected: false,
            slots: self._prepareSlots(item.programs)
          }
        })

        self.originalChannelsData = [].concat(self.channels)
        self.filterData()
        self.paginateData()

        // self.goto(self.startTime)
        if (self.selectedDate.isSame(moment(), 'day')) {
          self.now()
        }

        setTimeout(() => {
          self.showLoader = false
        }, self.showLoaderInterval)

        setTimeout(() => {
          // by changing the isScrolling value we force the recalculation of channels in viewport
          self.isScrolling = self.isScrolling + 10
        }, self.showLoaderInterval + 2000)
      })
      .catch(() => {
        setTimeout(() => { self.showLoader = false }, self.showLoaderInterval)
      })
    },
    filterData () {
      const channelsData = [].concat(this.originalChannelsData)
      const filters = this.selectedFilters

      this.channels = filters.length > 0 ? channelsData.filter((item) => {
        return filters.includes(item.category)
      }) : this.originalChannelsData

      this.paginateData()
      // console.log('this.channelImages', this.channelImages)
    },
    paginateData () {
      if (this.selectedFilters.length !== 0) {
        return false
      }
      const channelsData = [].concat(this.originalChannelsData)
      const pagination = this.pagination

      // set the last index
      this.pagination.lastIndex = channelsData.length

      if (this.pagination.lastIndex <= this.pagination.currentLastIndex) {
        this.pagination.isLast = true
      }

      this.channels = channelsData.filter((item, index) => {
        return (index <= pagination.currentLastIndex - 1)
      })

      // console.log('this.channelImages', this.channelImages)
    },
    showMore () {
      this.pagination.currentLastIndex += this.pageSize
      this.paginateData()
    },
    setChannelVisibility (channelId, inViewport) {
      const channelsData = [].concat(this.channels)
      this.channels = channelsData.map((item) => {
        if (+channelId === +item.id) {
          item.inViewport = inViewport
        }
        return item
      })
    },
    resizeHandler () {
      const self = this
      self.nowOffset = self._getOffsetByTime(self.currentTime) + 'px'
      self.timelineWidth = self.$refs.timeline.offsetWidth
      self.timelineRect = self.$refs.timeline.getBoundingClientRect()
      this.$refs.epgDays.recalculate(this.today_label[this.lang])
      // by changing the isScrolling value we force the recalculation of channels in viewport
      self.isScrolling = self.isScrolling++
    },
    scrollHandler () {
      const self = this
      setTimeout(() => {
        self.isScrolling = (window.pageYOffset || document.documentElement.scrollTop)
      }, 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Epg.vue?75b54511